<app-action-icon #iconCmp
                 [value]="isThumbset"
                 [state]="state"
                 (toggle)="toggleSetting($event)"
                 class="thumbsdown-icon__container"
                 [class.thumbsdown-icon__container--active]="isThumbset"
                 [class.thumbsdown-icon__container--hover]="iconCmp.hover">
  <mat-icon
    [matTooltip]="tooltip"
    class="thumbsdown-icon__icon"
    [class.thumbsdown-icon__icon--active]="isThumbset"
    [class.thumbsdown-icon__icon--hover]="iconCmp.hover">
    {{icon}}
  </mat-icon>
</app-action-icon>
